import createAxiosInstance from "../LambdaApiAdministracion";
import { ENVIROMENT } from "../../utilities";

export async function AddFetchSeccion(body) {
  const axiosInstance = await createAxiosInstance();
  const url = ENVIROMENT === "dev" ? `/admon/secciones` : `/home/admon/secciones`;
  const requestConfig = {
    method: "POST", // Cambia el método si es necesario
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  };
  return axiosInstance(requestConfig);
}
